<template>
  <v-col>
    <div class="box-skus d-flex">
      <div class="box-empty"></div>
      <div class="box-table-content">
        <v-simple-table class="table-custom" v-if="isShowSku">
          <thead>
            <tr>
              <th class="col-name text-left">SKU</th>
              <th class="col-code text-left">Mã SKU</th>
              <th class="col-subject text-left">Môn</th>
              <th class="col-price text-center">Giá</th>
              <th class="col-num-of-lesson text-center">Thời hạn</th>
              <th class="col-active text-left">Kích hoạt</th>
              <th class="col-status text-left">Trạng thái</th>
              <th class="col-status text">Giao dịch</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!data.length">
              <td colspan="7" v-if="!isLoading">Không có dữ liệu</td>
              <td colspan="7" v-if="isLoading">Đang tải dữ liệu...</td>
            </tr>
            <template v-if="data.length">
              <tr v-for="(item, index) in data" :key="index">
                <td class="text-left">{{ item.name }}</td>
                <td class="text-left">{{ item.code }}</td>
                <td class="text-left">{{ subjectsObj[item.subjectId] }}</td>
                <td class="text-center">{{ formatCurrency(item.orgPrice) }}</td>
                <td class="text-center">
                  <span v-if="item.durationType === 'month'">{{ item.duration }} tháng</span>
                  <span v-if="item.durationType === 'day'">{{ formatDate(item.endDate) }}</span>
                </td>
                <td class="text-left">{{ skuActivationObj[item.activationTypes[0]] }}</td>
                <td class="text-left">{{ skuStatusObj[item.status] }}</td>
                <td class="text-left">{{skuTransactionObj[item.transactionStatus]}}</td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
        <div class="d-flex justify-end pt-1">
          <i class="cursor-pointer" v-if="!isShowSku" @click="showListSku()">Mở rộng ({{ product.numOfSku }}) SKU <v-icon>mdi-chevron-down</v-icon></i>
          <i class="cursor-pointer" v-if="isShowSku" @click="hideListSku()">Thu gọn<v-icon>mdi-chevron-up</v-icon></i>
        </div>
      </div>
    </div>
  </v-col>
</template>

<script>
import * as moment from 'moment';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const ProductRepository = RepositoryFactory.get('product');

export default {
  name: 'dou-sku-in-list',
  components: {
  },
  props:{
    product: {
      type: Object,
      default: () => {},
    },
    productAttributes: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      isShowSku: false,
      data: [],
      isLoading: false,
      subjectsObj: {},
      skuActivationObj: {},
      skuStatusObj: {},
      skuTransactionObj: {},
    };
  },
  computed: {
  },
  async created() {
    this.productAttributes.subjects.forEach((item) => {
      this.subjectsObj[item.id] = item.name;
    });

    this.productAttributes.skuActivation.forEach((item) => {
      this.skuActivationObj[item.id || item.code] = item.name;
    });

    this.productAttributes.skuStatus.forEach((item) => {
      this.skuStatusObj[item.id || item.code] = item.name;
    });
    this.productAttributes.skuTransaction.forEach((item) => {
      this.skuTransactionObj[item.id || item.code] = item.name;
    });
  },
  beforeDestroy() {
  },
  methods: {
    compare(a, b) {
      if (b.id > a.id) {
        return 1;
      }
      if (a.id > b.id) {
        return -1;
      }
      return 0;
    },
    async showListSku() {
      this.isShowSku = true;
      this.isLoading = true;
      const params = {
        product_id: this.product.id,
        product_type: this.product.type
      };
      if (!this.data.length) {
        const res = await ProductRepository.advanceSearchForCombo(params);
        if (res.data) {
          const skuActive = [];
          const skuInActive = [];
          res.data.forEach((item) => {
            if (item.status === 'active') {
              skuActive.push(item);
            }
            if (item.status === 'inactive') {
              skuInActive.push(item);
            }
          })
          skuActive.sort(this.compare);
          skuInActive.sort(this.compare);
          this.data = skuActive.concat(skuInActive);
        }
      }
      this.isLoading = false;
    },
    hideListSku() {
      this.isShowSku = false;
    },
  },
  watch: {
  }
};
</script>
<style scoped lang="scss">
.box-skus {
  .box-empty {
    width: 5%;
  }
  .box-table-content {
    width: 95%;
  }
}
.table-custom {
  background: unset !important;

  thead th {
    background: unset;
    font-weight: bold !important;
    font-size: 14px;
  }

  td {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
}
.text-bold {
  font-weight: bold;
}

.col-name {
  width: 300px;
}
.col-code {

}
.col-subject {

}
.col-price {

}
.col-num-of-lesson {

}
.col-active {

}
.col-status {

}
</style>
